const EnumCanalAtendimentoOrigem = {
  PLATAFORMA_BENEFICIARIO: 'plataformaBeneficiario',
  PAINEL_OMNICHANNEL: 'painelOmnichannel',
  MOSIA_DESK: 'mosiaDesk'
}

export { EnumCanalAtendimentoOrigem }
